module.exports = __webpack_public_path__ + "static/JustAnotherHand-Regular-bcf61fe1957c0455bdc6c67a2131d62c.ttf";